var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13106_13111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 2.8335V54.1668M39.6667 12.1668H22.1667C20.0007 12.1668 17.9235 13.0272 16.392 14.5588C14.8604 16.0903 14 18.1676 14 20.3335C14 22.4994 14.8604 24.5767 16.392 26.1082C17.9235 27.6397 20.0007 28.5002 22.1667 28.5002H33.8333C35.9993 28.5002 38.0765 29.3606 39.608 30.8921C41.1396 32.4237 42 34.5009 42 36.6668C42 38.8328 41.1396 40.91 39.608 42.4415C38.0765 43.9731 35.9993 44.8335 33.8333 44.8335H14",
    stroke: "#232F3E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13106_13111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.a1df749ae9c7ab865f80c26a367a6437.svg";
export { ForwardRef as ReactComponent };